module.exports = __webpack_public_path__ + "img/sporting-braga-logo-icon.e2bc331a.png";